module.exports = __webpack_public_path__ + "static/media/FollowUPLogo.ddb88d91.svg";